import React from "react";
import {
  AppCard, AppCardContent, AppCardDescription, AppCardHeader, AppCardTitle, Radio,
} from "../../ui";

/**
 * Who the paper is for — the institute's own students, or anyone who comes in
 * through a public exam link. A public paper skips choosing students, is never
 * on a student's list and is announced to nobody; its link, dates, security
 * and results are set on the public exam instead.
 *
 * On a new assessment it opens the Format step; on an edit, the Details step.
 */
export default function UsageChoice({ value, onChange, disabled }) {
  const publicOnly = value === "public";
  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle>Who will take it?</AppCardTitle>
        <AppCardDescription>This decides the steps that follow. You can change it later.</AppCardDescription>
      </AppCardHeader>
      <AppCardContent>
        <fieldset className="tw-m-0 tw-grid tw-min-w-0 tw-gap-3 tw-border-0 tw-p-0 min-[768px]:tw-grid-cols-2">
          <legend className="tw-sr-only">Who will take it?</legend>
          <Radio
            variant="card"
            name="assessment-usage"
            checked={!publicOnly}
            onChange={() => onChange("students")}
            disabled={disabled}
            label="My students"
            description="Give it to batches, courses or chosen students. It shows on their list, and they are told when you publish."
          />
          <Radio
            variant="card"
            name="assessment-usage"
            checked={publicOnly}
            onChange={() => onChange("public")}
            disabled={disabled}
            label="Anyone, through a public exam link"
            description="For campus drives, hiring and entrance tests — no login needed. Your students won't see it and nobody is notified."
          />
        </fieldset>
      </AppCardContent>
    </AppCard>
  );
}
